import React, { createContext, useContext } from 'react';

const ReportsContext = createContext();

export const useReportsContext = () => {
  const context = useContext(ReportsContext);
  if (!context) {
    throw new Error('useReportsContext must be used within ReportsProvider');
  }
  return context;
};

export const ReportsProvider = ({ children, value }) => {
  return (
    <ReportsContext.Provider value={value}>
      {children}
    </ReportsContext.Provider>
  );
};
